import { useState, useEffect, useContext } from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import parse from 'html-react-parser';
import { withRouter, useLocation, Link } from 'react-router-dom';
import API from '../../../utils/api';
import moment from 'moment';
import { useTranslation} from 'react-i18next';
import "react-datepicker/dist/react-datepicker.css";
import { AuthContext } from '../../../context/AuthContext';
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import Banner from '../Banner';
import Accordion from 'react-bootstrap/Accordion';
import { useHistory } from "react-router-dom"
import * as department from "../../../actions/department";
import { connect } from "react-redux";
import { compose } from 'redux';
import arrow from '../../../assets/img/custom/arrow.png'
import BookingModal from '../../../page/bookingModal';
import Cookies from 'js-cookie'
import {Helmet} from "react-helmet";

const timeSlots = [
    { name: '9.00 AM', value: '9.00', disabled: false },
    { name: '9.30 AM', value: '9.30', disabled: false },
    { name: '10.00 AM', value: '10.00', disabled: false },
    { name: '10.30 AM', value: '10.30', disabled: false },
    { name: '11.00 AM', value: '11.00', disabled: false },
    { name: '11.30 AM', value: '11.30', disabled: false },
    { name: '12.00 PM', value: '12.00', disabled: false },
    { name: '12.30 PM', value: '12.30', disabled: false },
    { name: '1.00 PM', value: '13.00', disabled: false },
    { name: '1.30 PM', value: '13.30', disabled: false },
    { name: '2.00 PM', value: '14.00', disabled: false },
    { name: '2.30 PM', value: '14.30', disabled: false },
    { name: '3.00 PM', value: '15.00', disabled: false },
    { name: '3.30 PM', value: '15.30', disabled: false },
    { name: '4.00 PM', value: '16.00', disabled: false },
    { name: '4.30 PM', value: '16.30', disabled: false },
    { name: '5.00 PM', value: '17.00', disabled: false },
    { name: '5.30 PM', value: '17.30', disabled: false },
    { name: '6.00 PM', value: '18.00', disabled: false },
    { name: '6.30 PM', value: '18.30', disabled: false },
    { name: '7.00 PM', value: '19.00', disabled: false },
    { name: '7.30 PM', value: '19.30', disabled: false },
    { name: '8.00 PM', value: '20.00', disabled: false },
    { name: '8.30 PM', value: '20.30', disabled: false },
    { name: '9.00 PM', value: '21.00', disabled: false },
    { name: '9.30 PM', value: '21.30', disabled: false }
  ]

const DepartmentDetails = (props) => {
  const { t, i18n } = useTranslation();
    const location = useLocation();
    //let department = location?.state?.department;
    
    const { getAuthUser, isAuthenticated, getCurrentBranch } = useContext(AuthContext)
    const authUser = getAuthUser()
    const doctorId = location.state?.department?.doctor?.id;
    const isAuthentic = isAuthenticated()
    const history = useHistory()
    const [selected, setSelected] = useState(new Date());
    const [department, setDepartment] = useState(location?.state?.department ? location?.state?.department : {});
        const [year, setYear] = useState(new Date());
    const [open, setOpen] = useState(false);
    const [slots, setSlots] = useState(timeSlots);
    const [selectedSlot, setSelectedSlot] = useState("");
    const [show, setShow] = useState(false);
    const [stylePath, setStylePath] = useState(Cookies.get('fj_lang') === 'ar' ? "/assets/css/bootstrap.rtl.min.css" : "/assets/css/bootstrap.min.css");
    



    useEffect(() => {
      const onSuccess = (data) => {
  
        console.log('2233', data)
  
        setDepartment(data)
      }
  
      if (location?.state?.department) {
        setDepartment(location?.state?.department)
    
      } else {
        let params = new URLSearchParams(location.search);
        let gid = params.get('gid');
        let uid = params.get('uid');
        let language = location?.pathname?.split("/")?.pop();
        let title =location?.pathname?.split("/")?.[2].replaceAll("-"," ")
        //start change language
  
        if(Cookies.get('fj_lang') != language){
            if (language === 'en') {
                setStylePath("/assets/css/bootstrap.min.css")
            } else {
                setStylePath("/assets/css/bootstrap.rtl.min.css")
            }
      
            Cookies.set('fj_lang', language)
            i18n.changeLanguage(language);
            window.location.reload(false);
         
  
        }
       
        API.department().getByTitle(title)
        .then(res => {
       
          setDepartment(res.data)
        })
        .catch(err => console.log(err))
       // props.fetchById(uid, onSuccess)
  
      }
  
  
    }, [location?.state?.department])

  useEffect(() => {
    const onSuccess = (data) => {
    

      setDepartment(data)
    }
    
    if (location?.state?.department) {
      setDepartment(location?.state?.department)
    } else {

        props.fetchById(location.pathname.replaceAll("/department-details/", ""), onSuccess)

    }
 
   
}, [location?.state?.department])




  useEffect(() => {
    setOpen(false)
    setSelectedSlot("")
    setSlots([])
   // console.log('------->',new Date(selected).toISOString().split('T')[0]+'T00:00:00.000+00:00',doctorId)
    API.doctorbooking().getAvailableTimeSlots({
      doctor: doctorId,
      bookingDate: new Date(selected).toISOString().split('T')[0]+'T00:00:00.000+00:00',
    })
      .then(res => {

        let booked = res.data
        //console.log('---->1',booked)
        let sl = timeSlots;
        if(new Date(selected)===new Date().toISOString().split('T')[0]){
        
          sl.filter((ele, index) => {
            sl[index].disabled = false
        
            if (parseInt(ele.value)<parseInt(moment(new Date()).format("HH:mm"))+0.60) {
              sl[index].disabled = true
            }else{
              if (booked.includes(ele.value)) {
                sl[index].disabled = true
              }
            }
          })
        }else{
          sl.filter((ele, index) => {
            sl[index].disabled = false
            if (booked.includes(ele.value)) {
              sl[index].disabled = true
            }
          })
        }
        
        console.log(sl)
        setSlots(sl)
      })
      .catch(err => console.log(err))

  }, [selected]);

  const confirmBooking = () => {
   
    API.doctorbooking().create({
      doctor: [doctorId],
      customer: authUser.id,
      services:[],
      type:'doctor',
      bookingDate: selected,
      bookingTime: selectedSlot,
      status: 'pending',
    })
      .then(res => {
        handleClose()
        Swal.fire({
            title: 'Thank you for booking!',
            text: 'Our customer service agent will call you for appointment confirmation.',
            icon: 'success',
            showConfirmButton: true,
          
          })
      })
      .catch(err => console.log(err))


  };

  const handleClose = () => {setShow(false)
    setSelected(new Date())
    setSelectedSlot("")
};
const handleShow = () =>{
  if(!isAuthentic){
    history.push('/login')
    return
  }

  setShow(true);
} 

    return (
       department?.id ?
        <>
        <Banner title={department?.title[i18n.language]} />
        <section className='mb-5'>
                <div className="container">
                    <div className="row area_boxed">
                      <div className='col-lg-12 col-12'>
                      
                      <img className={`d-block w-50  mr-3 ${i18n.language === 'en' ? 'float-right' : 'float-left'}`} src={process.env.REACT_APP_IMG_URL+department?.gallary[0]} />
<div className="product_description">
<h3>{department?.title[i18n.language]}</h3>
{department?.description?.en?.length && <div className='htmparser'>{parse(department?.description[i18n.language])}</div>}

</div>

                      </div>
                   
                    </div>
                
                </div>
            </section>
           

            {department?.doctor && <section className='bg-depart-old'>
            <div className="container py-5">
                    <div className="row area_boxed">
                    <div className="col-lg-4" style={{marginTop: '8%'}}>
                                <div className="team_slider">

                                    <div className="team-single">
                                    <img src={process.env.REACT_APP_IMG_URL + department?.doctor.image} className="doctorImg" />
                                        <div className="team-bottom">
                                            <p>{department?.doctor.name[i18n.language]}</p>
                                            <p className="text-black font-weight-bold">{department?.doctor.education[i18n.language]}</p>
                                            <p className="team-title small">{department?.doctor.experience[i18n.language]} {t('experince')}</p>
                                            <Link
                                            
                                            to={{
                                              pathname: `/doctor-details/${(department?.doctor?.name?.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`
                                              , state: {
                                                  doctor: department?.doctor
                                              }
                                          }}
                                             >
                                                <p className='text-warn font-weight-light small my-1'>{t("viewprofle")} <img src={arrow} style={{ height: 10 }} /></p>
                                            </Link>
                                            <BookingModal type="doctor" servicename={department?.doctor.name[i18n.language]} service={department?.doctor._id}/>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        <div className="col-lg-8">
                            <div className="product_details_right_one">
                                <div className="modal_product_content_one">
                                   
                            <div className="product_details_right_one">
                                <div className="modal_product_content_one">
                                    {/* <h3>{department?.doctor?.name[i18n.language]}</h3> */}
                                    {/* <div className="reviews_rating">
                              
                                        <span><i className='fa fa-graduation-cap'></i>  {department?.doctor?.education[i18n.language]},  {department?.doctor?.experience[i18n.language]} {t('experince')}</span>
                                    </div> */}
                                   
                                    <div className='htmparser'>{parse(department?.doctor?.about[i18n.language])}</div>
                                    {/* <p>{department.doctor?.about} </p> */}
                                   {/* <br />
                                    <div className="links_Product_areas">
                                        
                                        <a className="theme-btn-one btn-black-overlay btn_sm" onClick={handleShow}>{t('bookappt')}</a>
                                    </div> */}

                                </div>
                            </div>
            
                                </div>
                            </div>
                        </div>
                    </div>
                
                </div>
            </section>}
            <section className='my-5'>
                <div className="container">
                    <div className="row area_boxed">
                    
                        <div className="col-lg-8">

                        <h4 className='mb-3'>{t('frequestasks')}</h4>
                        <Accordion defaultActiveKey="0" flush>
                         {
                            department?.qna?.map((data,i) =>
                            <Accordion.Item eventKey={i}>
                            <Accordion.Header as='p' bsPrefix='accord-head'>{data.question[i18n.language]}</Accordion.Header>
                            <Accordion.Body bsPrefix='accord-body'>
                            {data.answer[i18n.language]}
                            </Accordion.Body>
                            </Accordion.Item>
                            )
                         }   
                        
                        
                        </Accordion>

     
                        </div>
                        <div className="col-lg-4">
                            <div className="product_single_two_img slider-for">
                            <img src={process.env.REACT_APP_IMG_URL+department?.gallary[1]} alt="img" />
                            </div>

                        </div>
                    </div>
                
                </div>


            </section>
          

            <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t('bookappt')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className='row'>
            <div className='col-lg-6'>
            

            <div className="form-group">
                <label for="exampleInputEmail1">Date</label>
                {/* <DatePicker className="btn-block form-control" 
                minDate={new Date()}
                
                selected={selected} onChange={(date) => setSelected(date)} /> */}

<input className="form-control" type="date" min={new Date().toISOString().split("T")[0]}  onChange={(e) => setSelected(e.target.value)}/>
               
            </div>
            </div>
            <div className='col-lg-6'>
            <div className="form-group">
                <label>Choose Time</label>
       
    <select className="form-control" onChange={(e)=>setSelectedSlot(e.target.value)}>
      <option>Choose</option>
      {slots.map((e,index) => <option key={index} value={e.value} disabled={e.disabled}>{e.name}</option>)}
    </select>
            </div>
            </div>
            <div className='col-lg-12'>
              
            <small className="form-text text-muted">Date & time will be confirmed by our customer service agent</small>
            </div>
        </div>
        </Modal.Body>
        <Modal.Footer>
           {/* <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button> */}
        <button type="button" className="btn bg-adam" onClick={confirmBooking}>{t('booknow')}</button>
        </Modal.Footer>
                </Modal>  
        </>: <>
 <div className='py-5 text-center'>
 <div className="spinner-border text-secondary" role="status">
<span className="sr-only">Loading...</span>
</div>
 </div>
 
 </> 
    )
}

const mapStateToProps = state => ({
  
  currentDepartment: state.department.currentDepartment,

})
const mapActionToProps = {
 
  fetchById : department.fetchById,

}


export default compose(
  withRouter,
  connect(mapStateToProps, mapActionToProps)
)(DepartmentDetails);